import {
    ExpandIcon,
    ReloadIcon
} from 'common/components/icons';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CudaPaper from 'common/components/CudaPaper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Translate } from 'react-i18nify-lite';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const styles = {
    container: {
        
        
    },
    emptyTableCell: {
        textAlign: 'center',
        fontSize: '16px',
        color: '#777777',
        fontWeight: '300',
        height: '150px',
    },
    actionHeadCell: {
        width: '100px',
        textAlign: 'center'
    },
    actionCell: {
        display: 'flex',
        justifyContent: 'center'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
      },
    expandOpen: {
    transform: 'rotate(180deg)',
    },
    reloadButtonDiv: {
        margin: 0,
    },
}

class Dashboard extends React.Component {
    state = { expanded: true };
  
    handleExpandClick = () => {
      this.setState(state => ({ expanded: !state.expanded }));
    };
  
    render() {
        const {
                classes,
                isLoading,
                items,
                reload,
            } = this.props;
    
    return (
        <Grid className={classes.container} style={this.state.expanded ? {height:'100%'} : {height:'auto'}}>
            <CudaPaper loading={isLoading} >
        <CardActions className={classes.actions} disableactionspacing="true">
          Problematic Services

          
          <Button className={classes.button} onClick={reload}>
            <ReloadIcon />
          </Button>
          
          <IconButton
            className={classnames(classes.expand, {
              [classes.expandOpen]: this.state.expanded,
            })}
            onClick={this.handleExpandClick}
            aria-expanded={this.state.expanded}
            aria-label="Show more"
          >
            <ExpandIcon />
          </IconButton>
        </CardActions>

            <Collapse in={this.state.expanded}  timeout="auto" unmountOnExit>

            <Grid item xs={12} className={classes.tableContainer}>
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell>Service Id</TableCell>
                                <TableCell>ip</TableCell>
                                <TableCell>port</TableCell>
                                <TableCell>type</TableCell>
                                <TableCell>managed_service id/name</TableCell>
                                <TableCell>account id/name</TableCell>
                                <TableCell>problematic table</TableCell>
                                <TableCell>WAF</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.length > 0 ?
                                items.map((server, i) => {
                                    return (
                                        <TableRow key={i}>
                                            <TableCell>
                                                {server.waas_service_id}
                                            </TableCell>
                                            <TableCell>
                                                {server.waas_service__dps_service__ip__ip}
                                            </TableCell>
                                            <TableCell>
                                                {server.waas_service__dps_service__port}
                                            </TableCell>
                                            <TableCell>
                                                {server.waas_service__protocol}
                                            </TableCell>
                                            <TableCell>
                                                {server.waas_service__managed_service_id}
                                                /
                                                {server.waas_service__managed_service__name}
                                            </TableCell>
                                            <TableCell>
                                                {server.waas_service__managed_service__account_id}
                                                /
                                                {server.waas_service__managed_service__account__name}
                                            </TableCell>
                                            <TableCell>
                                                {server.failed_modules.join(", ")}
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant='caption' color='secondary'>Hostname:</Typography><br/>
                                                {server.cwaf__hostname}<br/>
                                                <Typography variant='caption' color='secondary'>Region(s):</Typography><br/>
                                                {server.cwaf__esxi__dc__description && server.cwaf__esxi__dc__description}
                                                {server.waas_service__regions__display_name && server.cwaf__esxi__dc__description && <br/>}
                                                {server.waas_service__regions__display_name && server.waas_service__regions__display_name}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                                :
                                <TableRow >
                                    <TableCell colSpan="8" className={classes.emptyTableCell}>
                                        <Translate value="applications.problematicServers.noServers" />
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
            </Grid>
            </Collapse>
            
            </CudaPaper>
        </Grid>
    )};


};

export default withStyles(styles)(Dashboard);
